var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Metabase"}},[_c('metabase-dashboard',{attrs:{"dashboard-id":56,"params":"theme=transparent&bordered=false&titled=false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }